document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
   const ufeBtns = document.querySelectorAll('.ufe-btn');
    
    ufeBtns.forEach(element => {  

    if(document.querySelector('#bundle .add-to-cart').hasAttribute('disabled')){

      element.setAttribute('disabled', 'true');   

    }

    });
    
    function removeDisabled() {
      ufeBtns.forEach(element => {  

        element.removeAttribute('disabled');   

      });
    }
    
    let collectionSelected = document.querySelectorAll('#bundle ul.products-list li');

    collectionSelected.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if(document.querySelectorAll('#bundle ul.products-list li.selected').length > 1) {
        	removeDisabled();
        };
      });
    });

  }, 1500);
  

});